import { render, staticRenderFns } from "./IndicationTemp.vue?vue&type=template&id=2c08635e&scoped=true"
import script from "./IndicationTemp.vue?vue&type=script&lang=js"
export * from "./IndicationTemp.vue?vue&type=script&lang=js"
import style0 from "./IndicationTemp.vue?vue&type=style&index=0&id=2c08635e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c08635e",
  null
  
)

export default component.exports